if (!customElements.get('gifting-sticky-cart')) {
  customElements.define('gifting-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.requestVersion = 0;
      this.refresh = this.refresh.bind(this);
      this.onCartUpdate = ({ cartData } = {}) => {
        if (Number.isInteger(cartData?.item_count)) {
          ++this.requestVersion;
          this.renderCart(cartData);
        } else {
          this.refresh();
        }
      };
      this.onOpen = () => {
        const drawer = document.querySelector('cart-drawer');
        drawer ? drawer.open(this.querySelector('[data-open-cart]')) : (window.location.href = window.routes.cart_url);
      };
      this.querySelector('[data-open-cart]').addEventListener('click', this.onOpen);
      document.addEventListener('gifting:cart-updated', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      }
      this.refresh();
    }
    disconnectedCallback() {
      ++this.requestVersion;
      this.unsubscribe?.();
      document.removeEventListener('gifting:cart-updated', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      this.querySelector('[data-open-cart]').removeEventListener('click', this.onOpen);
    }
    async refresh() {
      const version = ++this.requestVersion;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (version === this.requestVersion && this.isConnected) this.renderCart(cart);
      } catch (_) { /* Keep the last confirmed cart state when offline. */ }
    }
    renderCart(cart) {
      const pluralForm = new Intl.PluralRules(document.documentElement.lang || 'en').select(cart.item_count);
      const countTemplate = pluralForm === 'one' ? this.dataset.countOne : this.dataset.countOther;
      this.querySelector('[data-count]').textContent = countTemplate.replace('[count]', String(cart.item_count));
      this.querySelector('[data-total]').textContent = (cart.total_price / 100).toLocaleString(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: cart.currency || window.Shopify.currency.active
      });
      this.classList.toggle('is-hidden', cart.item_count === 0);
    }
  });
}
